import { render, staticRenderFns } from "./ChatAssistant.vue?vue&type=template&id=02d4d605&scoped=true"
import script from "./ChatAssistant.vue?vue&type=script&lang=js"
export * from "./ChatAssistant.vue?vue&type=script&lang=js"
import style0 from "./ChatAssistant.vue?vue&type=style&index=0&id=02d4d605&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d4d605",
  null
  
)

export default component.exports